<template>
<!-- 概述图样式 -->
  <div
    id="gaishuPic"
    class="gaishuPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
  <div class="gaishuContent">
    <div class="join-people" v-if="tb.numberMin || tb.numberMax ">
      <span  class="label white">参与人数:</span>
      <span  class="value white">{{tb.numberMin?tb.numberMin:'-'}}~{{tb.numberMax?tb.numberMax:'-'}}</span>
    </div> 
    <div class="city" v-if="tb.cityName">
      <span  class="label white">活动地点:</span>
      <span  class="value white">{{tb.cityName}}</span>
    </div> 
  </div>
 
  </div>
</template>

<script>
export default {
  name: "gaishuPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tb","backgroundPic","type"],
  methods: {
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#gaishuPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}

.gaishuContent{
  position: absolute;
  box-sizing: border-box;
  padding: 0 270px;
  display: flex;
  justify-content: space-around;
  top: 440px;
  width: 100%;
}

.white{
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/gaishuPic.vue